import { gql } from '@apollo/client'

export const DESTROY_CUSTOMER_ADDRESS = gql`
  mutation DestroyCustomerAddress($input: DestroyCustomerAddressInput!) {
    destroyCustomerAddress(input: $input) {
      customerAddress {
        id
      }
    }
  }
`
